const SolutionComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-02">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="text-3xl font-bold mb-12 custom-color-01">
          O que acontece quando a Bíblia é aplicada de forma consistente e
          profunda?
        </h3>

        <div className="rounded-2xl p-8 mb-8 border-2 custom-bg-color-01 custom-border-color-05 custom-color-03">
          <p className="leading-relaxed mb-4">
            Quando os princípios bíblicos são compreendidos em sua totalidade e
            aplicados com sabedoria, eles oferecem direção, esperança e
            transformação genuína para os desafios mais complexos.
          </p>
          <p className="leading-relaxed">
            O congresso propõe um caminho claro, fundamentado nas Escrituras,
            para lidar com questões como depressão, vícios, pecados
            persistentes, conflitos relacionais e as mais diversas questões da
            alma.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg border-2 custom-border-color-03 custom-color-03">
          <h4 className="text-2xl font-semibold mb-4">
            Um ambiente de formação que une teologia, prática e comunidade
          </h4>
          <p className="leading-relaxed mb-4">
            O diferencial do Congresso Vida&Piedade está na união entre
            fundamentação teológica, recursos práticos e a troca de experiências
            entre líderes comprometidos.
          </p>
          <p className="leading-relaxed">
            Você terá acesso a conteúdos cuidadosamente selecionados,
            ministrados por conselheiros experientes, e a uma rede de apoio para
            o seu ministério.
          </p>
        </div>
      </div>
    </section>
  );
};
export default SolutionComponent;
